// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu",
    "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  font-family: Arial, sans-serif;
  background-color: #f8f9fa;
}

code {
  font-family:
    source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

.hero-section img {
  filter: brightness(0.8);
}

/* input */
.image-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 10px;
  transform: rotate(-45deg);
  margin: 20px auto;
  width: 250px;
  height: 250px;
  border: 2px solid rgb(240, 232, 232);
}

.grid-item {
  width: 100%;
  /* height: auto; */
  transform: rotate(45deg);
}

.small {
  width: 100px;
  height: auto;
}

/* event */
.event-img {
  width: 100%;
  height: auto;
  border-radius: 5px;
}

.event-title {
  font-size: 1.2rem;
  font-weight: bold;
  margin-top: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;wEAEsE;EACtE,mCAAmC;EACnC,kCAAkC;;EAElC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE;sEACoE;AACtE;;AAEA;EACE,uBAAuB;AACzB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,qCAAqC;EACrC,kCAAkC;EAClC,SAAS;EACT,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA,UAAU;AACV;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":["body {\n  margin: 0;\n  font-family:\n    -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\",\n    \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n  font-family: Arial, sans-serif;\n  background-color: #f8f9fa;\n}\n\ncode {\n  font-family:\n    source-code-pro, Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\n\n.hero-section img {\n  filter: brightness(0.8);\n}\n\n/* input */\n.image-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-template-rows: repeat(2, 1fr);\n  gap: 10px;\n  transform: rotate(-45deg);\n  margin: 20px auto;\n  width: 250px;\n  height: 250px;\n  border: 2px solid rgb(240, 232, 232);\n}\n\n.grid-item {\n  width: 100%;\n  /* height: auto; */\n  transform: rotate(45deg);\n}\n\n.small {\n  width: 100px;\n  height: auto;\n}\n\n/* event */\n.event-img {\n  width: 100%;\n  height: auto;\n  border-radius: 5px;\n}\n\n.event-title {\n  font-size: 1.2rem;\n  font-weight: bold;\n  margin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
